// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".es-toast__heading[data-v-bdce2c32]{font-weight:700;padding-bottom:4px}.es-toast__details[data-v-bdce2c32]{border-top:1px solid rgba(0,0,0,.2);padding:10px 0;font-size:12px;margin-top:10px}.es-toast__detail[data-v-bdce2c32]{padding:5px 0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
